import { render, staticRenderFns } from "./AxWrapper.vue?vue&type=template&id=2ff3610b&scoped=true"
import script from "./AxWrapper.vue?vue&type=script&lang=ts"
export * from "./AxWrapper.vue?vue&type=script&lang=ts"
import style0 from "./AxWrapper.vue?vue&type=style&index=0&id=2ff3610b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff3610b",
  null
  
)

export default component.exports